import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ModuleScene } from '../scenes/ModuleScene';
import { SectionHeader } from '../ui/SectionHeader';
import { modules } from '../../data/modules';
import type { ModuleId } from '../../types/content';
interface ModulesShowcaseProps {
  id?: string;
  title?: React.ReactNode;
  body?: React.ReactNode;
}
export function ModulesShowcase({
  id,
  title = 'A connected foundation. Configured around your work.',
  body = 'Organizations use the modules relevant to their work, and nothing more. Research and clinical workflows do not depend on civic assessment.'
}: ModulesShowcaseProps) {
  const [active, setActive] = useState<ModuleId>('knowledge');
  return <section id={id} className="scroll-mt-24 py-24 md:py-32" data-id="element-454" data-mp="hkf5i6v65boj">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-455" data-mp="2xd4muxd3931q">
        <SectionHeader title={title} body={body} data-id="element-456" data-mp="2xfqwd2jjhsml" />

        <div className="mt-14 grid gap-8 lg:grid-cols-[1fr_1.1fr] lg:gap-14" data-id="element-457" data-mp="32dikdlh2culi">
          <div role="tablist" aria-label="Modules" aria-orientation="vertical" className="flex flex-col" data-id="element-458" data-mp="2m0098va1mvw2">
            {modules.map(m => {
            const selected = m.id === active;
            const Icon = m.icon;
            return <button key={m.id} role="tab" type="button" aria-selected={selected} aria-controls="module-panel" onClick={() => setActive(m.id)} className={`group flex gap-4 border-t border-ink/[0.08] py-5 text-left transition-colors duration-150 last:border-b ${selected ? '' : 'hover:bg-white/40'}`} data-id="element-459" data-mp="2w00wgsb19w5j">
                  <span className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-colors duration-150 ${selected ? 'bg-accent text-white' : 'bg-white text-ink-soft ring-1 ring-ink/[0.06]'}`} data-id="element-460" data-mp="39qntmg15bdzi">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-461" data-mp="3qtbgjivtm229" />
                  </span>
                  <span className="flex-1" data-id="element-462" data-mp="3vr4p2iklj85p">
                    <span className={`block text-lg font-semibold tracking-tight ${selected ? 'text-ink' : 'text-ink-soft'}`} data-id="element-463" data-mp="4kjyezyge297">
                      {m.name}
                    </span>
                    <span className="mt-1 block text-[15px] leading-relaxed text-ink-muted" data-id="element-464" data-mp="ea3jmc9n2878">{m.summary}</span>
                  </span>
                </button>;
          })}
          </div>

          <div id="module-panel" role="tabpanel" className="glass relative min-h-[380px] rounded-[28px] p-6 md:p-8" data-id="element-465" data-mp="narwv4r7k4j2">
            <AnimatePresence mode="wait" initial={false} data-id="element-466" data-mp="saec1jqljuui">
              <motion.div key={active} initial={{
              opacity: 0,
              y: 8
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -8
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-467" data-mp="s7s3phvvtbb8">
                <ModuleScene id={active} data-id="element-468" data-mp="2mj9s8vc4ahd0" />
                <div className="mt-6 flex flex-wrap gap-1.5" data-id="element-469" data-mp="2hr9vtcv9a6l6">
                  {modules.find(m => m.id === active)?.capabilities.map(c => <span key={c} className="rounded-full bg-white/80 px-2.5 py-1 text-[12px] text-ink-soft ring-1 ring-ink/[0.05]" data-id="element-470" data-mp="27su5hc41z1cq">
                        {c}
                      </span>)}
                </div>
              </motion.div>
            </AnimatePresence>
            <p className="absolute bottom-5 right-6 text-[11px] text-ink-faint" data-id="element-471" data-mp="30fn8k14x0cpw">Sample content</p>
          </div>
        </div>
      </div>
    </section>;
}